import React, { useState } from 'react';
import { Box, Tabs, Tab } from '@mui/material';
import RolesManager from './RolesManager';
import PermissionsManager from './PermissionsManager';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role='tabpanel'
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

const RolePermissionManager: React.FC = () => {
  const [value, setValue] = useState(0);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: '100%' }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label='role permission tabs'
        >
          <Tab label='Roles' />
          <Tab label='Permissions' />
        </Tabs>
      </Box>
      <TabPanel value={value} index={0}>
        <RolesManager />
      </TabPanel>
      <TabPanel value={value} index={1}>
        <PermissionsManager />
      </TabPanel>
    </Box>
  );
};

export default RolePermissionManager;
